export const getDisplayAddress = address => {
    let displayLocation = '';
    displayLocation += address.city ?? '';
    displayLocation += address.city && address.stateProvince ? ', ' : '';
    displayLocation += address.stateProvince ?? '';

    return displayLocation;
};

export const getCityStateDisplay = ({ city, state }) => {
    let cityState = '';

    if (city) {
        cityState += city;
    }

    if (city && state) {
        cityState += ', ';
    }

    if (state) {
        cityState += state;
    }

    return cityState;
};

export const getCityStateZipDisplay = address => {
    let text = '';

    if (address.city) {
        text += address.city;
    }

    if (address.city && address.stateProvince) {
        text += ', ';
    }

    if (address.stateProvince) {
        text += address.stateProvince;
    }

    if (address.zip) {
        text += ` ${address.zip}`;
    }

    return text;
};

export const getGoogleMapsUrl = address => {
    const key = 'AIzaSyCu3Nd4f60V-LnEFxRzGHoj4MC-K7FCQns';
    const searchTerms = [];

    if (address.address) {
        searchTerms.push(address.address.split(' ').join('+'));
    }

    if (address.address2) {
        searchTerms.push(address.address2.split(' ').join('+'));
    }

    if (address.address3) {
        searchTerms.push(address.address3.split(' ').join('+'));
    }

    if (address.city) {
        searchTerms.push(address.city.split(' ').join('+'));
    }

    if (address.stateProvince) {
        searchTerms.push(address.stateProvince.split(' ').join('+'));
    }

    if (address.zip) {
        searchTerms.push(address.zip.split(' ').join('+'));
    }

    if (address.country) {
        searchTerms.push(address.country.split(' ').join('+'));
    }

    return `https://www.google.com/maps?key=${key}&q=${searchTerms.join('+')}`;
};
